/**
 * H4 review F11: the API answers `403 TERMS_NOT_ACCEPTED` once the terms changed mid-session (a new
 * `TERMS_VERSION`). The HTTP clients report it here; `TermsGate` listens and shows the accept
 * screen at once, instead of pages showing errors until the next reload.
 */
export const TERMS_REQUIRED_EVENT = "lms:terms-required";

export function isTermsNotAcceptedBody(body: unknown): boolean {
  return (
    typeof body === "object" &&
    body !== null &&
    (body as { error?: { code?: unknown } }).error?.code === "TERMS_NOT_ACCEPTED"
  );
}

export function notifyTermsRequired(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(TERMS_REQUIRED_EVENT));
}

/** apiFetch: reads a clone of a 403, so the caller can still read the body. */
export async function reportTermsRefusal(res: Response): Promise<void> {
  if (res.status !== 403) return;
  try {
    if (isTermsNotAcceptedBody(await res.clone().json())) notifyTermsRequired();
  } catch {
    // Not JSON: not the terms refusal.
  }
}
